import {getNotifications} from "reduxModules/notifications"

export const notificationMiddleware = store => next => action => {
  if (action.type.includes("@@router")) {
    store.dispatch(getNotifications())
  }
  return next(action)
}